import MyCustomerVue from '@/views/sic/my-customer/my-customer.vue';

const basePath = '/sic/my-customer';
const role = 'sic'; // 角色身份

export const SIC_MY_CUSTOMER_INDEX = 'sic-my-customer-index';
export const SIC_MY_CUSTOMER_RESERVATION_EDIT = 'sic-my-customer-reservation-edit';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: MyCustomerVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index/:userId`,
      name: SIC_MY_CUSTOMER_INDEX,
      props: true,
      component: () => import(
        /* webpackChunkName: "my-customer-index" */
        `@/views/${role}/my-customer/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/edit/:id`,
      name: SIC_MY_CUSTOMER_RESERVATION_EDIT,
      props: true,
      component: () => import(
        /* webpackChunkName: "my-customer-reservation-edit" */
        `@/views/${role}/my-customer/edit.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
